import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderKanban, Hourglass, Inbox, MapPinOff } from 'lucide-react';
import { Empty } from '../components/atoms';
import { setPageTitle } from '../lib/seo';
import { useT } from '../lib/session';
import { useChrome } from '../layout/shell-context';
import { GoToCard, ProjectTree } from '../layout/sidebar-parts';

function useSimpleChrome(title: string) {
  useChrome(
    {
      section: 'Work',
      current: <span className="nm">{title}</span>,
      secondaryTitle: title,
      secondary: (
        <>
          <div className="glabel" style={{ paddingTop: 4 }}>All projects</div>
          <ProjectTree />
        </>
      ),
      rail: <GoToCard />,
    },
    [title],
  );
}

/** Planned screens (Reports, Clients…) that come in a later phase. */
export function ComingSoon({ title }: { title: string }) {
  const nav = useNavigate();
  const t = useT();
  useEffect(() => setPageTitle(title), [title]);
  useSimpleChrome(title);
  return (
    <div className="page">
      <div className="card">
        <Empty
          icon={<Hourglass />}
          title={`${title} is coming soon`}
          text="This screen is planned for a later phase. Use Projects, My Missions or Inbox in the meantime."
          actions={
            <>
              <button className="btn btn-p" onClick={() => nav('/projects')}><FolderKanban />Go to Projects</button>
              <button className="btn btn-o" onClick={() => nav('/my')}>{t.myItems}</button>
              <button className="btn btn-o" onClick={() => nav('/inbox')}><Inbox />Inbox</button>
            </>
          }
        />
      </div>
    </div>
  );
}

export function NotFound() {
  const nav = useNavigate();
  useEffect(() => setPageTitle('Page not found'), []);
  useSimpleChrome('Not found');
  return (
    <div className="page">
      <div className="card">
        <Empty icon={<MapPinOff />} title="We couldn’t find that page" text="The link may be old, or the item was moved or deleted." actions={<button className="btn btn-p" onClick={() => nav('/')}>Back to home</button>} />
      </div>
    </div>
  );
}
